var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernancesSpeciallyAbled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13506_34426)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13506_34426",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 13,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H40V37H16V13Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13506_34426)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.619 16.1691C21.6907 16.6223 22.4697 17.6303 22.5995 18.8319C22.6113 18.9404 22.5759 19.049 22.5027 19.1293C22.4295 19.2095 22.3257 19.2568 22.2171 19.2568H16.4762C16.3676 19.2568 16.2637 19.2095 16.1905 19.1293C16.1197 19.049 16.0843 18.9404 16.0961 18.8319C16.2259 17.6303 17.0049 16.6223 18.0766 16.1691C17.7249 15.8339 17.5054 15.3594 17.5054 14.8378C17.5054 13.8203 18.3316 12.9941 19.3466 12.9941C20.364 12.9941 21.1902 13.8203 21.1902 14.8378C21.1902 15.3594 20.9707 15.8339 20.619 16.1691ZM19.3466 16.6814C18.2065 16.6814 17.2434 17.4438 16.9412 18.4896H21.7521C21.4523 17.4438 20.4891 16.6814 19.3466 16.6814ZM19.3466 15.9142C19.9415 15.9142 20.4231 15.4303 20.4231 14.8378C20.4231 14.2429 19.9415 13.7613 19.3466 13.7613C18.7541 13.7613 18.2726 14.2452 18.2726 14.8378C18.2726 15.4303 18.7541 15.9142 19.3466 15.9142ZM29.2611 16.1691C30.3328 16.6223 31.1141 17.6303 31.2416 18.8319C31.2534 18.9404 31.218 19.049 31.1448 19.1293C31.0716 19.2095 30.9678 19.2568 30.8592 19.2568H25.1182C25.0097 19.2568 24.9058 19.2095 24.8326 19.1293C24.7594 19.049 24.7264 18.9404 24.7382 18.8319C24.8657 17.6303 25.647 16.6223 26.7187 16.1691C26.367 15.8339 26.1475 15.3594 26.1475 14.8378C26.1475 13.8203 26.9737 12.9941 27.9887 12.9941C29.0061 12.9941 29.8323 13.8203 29.8323 14.8378C29.8323 15.3594 29.6128 15.8339 29.2611 16.1691ZM27.9887 16.6814C26.8485 16.6814 25.8854 17.4438 25.5833 18.4896H30.3941C30.0943 17.4438 29.1312 16.6814 27.9887 16.6814ZM27.9887 15.9142C28.5812 15.9142 29.0651 15.4303 29.0651 14.8378C29.0651 14.2429 28.5812 13.7613 27.9887 13.7613C27.3962 13.7613 26.9146 14.2452 26.9146 14.8378C26.9146 15.4303 27.3962 15.9142 27.9887 15.9142ZM37.9031 16.1691C38.9748 16.6223 39.7538 17.6303 39.8837 18.8319C39.8955 18.9404 39.8601 19.049 39.7869 19.1293C39.7137 19.2095 39.6098 19.2568 39.5012 19.2568H33.7603C33.6517 19.2568 33.5479 19.2095 33.4747 19.1293C33.4015 19.049 33.3685 18.9404 33.3803 18.8319C33.5077 17.6303 34.2891 16.6223 35.3608 16.1691C35.0067 15.8339 34.7872 15.3594 34.7872 14.8378C34.7872 13.8203 35.6157 12.9941 36.6308 12.9941C37.6458 12.9941 38.4744 13.8203 38.4744 14.8378C38.4744 15.3594 38.2549 15.8339 37.9031 16.1691ZM36.6308 16.6814C35.4906 16.6814 34.5275 17.4438 34.2254 18.4896H39.0362C38.7364 17.4438 37.7733 16.6814 36.6308 16.6814ZM36.6308 15.9142C37.2233 15.9142 37.7072 15.4303 37.7072 14.8378C37.7072 14.2429 37.2233 13.7613 36.6308 13.7613C36.0383 13.7613 35.5567 14.2452 35.5567 14.8378C35.5567 15.4303 36.0383 15.9142 36.6308 15.9142ZM29.6458 27.1175V29.3907C29.6458 29.5324 29.5703 29.6598 29.4475 29.7283L26.9005 31.121C26.7824 31.1848 26.6361 31.1824 26.5204 31.1139C26.4048 31.0431 26.3316 30.918 26.3316 30.7835V27.1175L22.8238 23.4609C22.7553 23.3901 22.7152 23.2957 22.7152 23.1942V21.157C22.7152 20.9469 22.8875 20.7746 23.0999 20.7746H32.8775C33.0899 20.7746 33.2622 20.9469 33.2622 21.157V23.1942C33.2622 23.2957 33.2245 23.3901 33.156 23.4609L29.6458 27.1175ZM32.495 22.8118V21.5418H23.4847V22.8118H32.495ZM23.9993 23.579L26.9925 26.6973C27.061 26.7681 27.1011 26.8625 27.1011 26.9617V30.1367L28.8786 29.1641V26.9617C28.8786 26.8625 28.9164 26.7681 28.9849 26.6973L31.9781 23.579H23.9993ZM20.8928 32.3698V36.4016C20.8928 36.6141 20.7205 36.784 20.508 36.784H16.4762C16.2661 36.784 16.0938 36.6141 16.0938 36.4016V32.3698C16.0938 32.1597 16.2661 31.9874 16.4762 31.9874H20.508C20.7205 31.9874 20.8928 32.1597 20.8928 32.3698ZM20.1233 32.7545H16.8609V36.0169H20.1233V32.7545ZM27.9887 31.9874C29.313 31.9874 30.3894 33.0614 30.3894 34.3857C30.3894 35.71 29.313 36.784 27.9887 36.784C26.6644 36.784 25.5904 35.71 25.5904 34.3857C25.5904 33.0614 26.6644 31.9874 27.9887 31.9874ZM27.9887 32.7545C27.0893 32.7545 26.3575 33.4863 26.3575 34.3857C26.3575 35.2874 27.0893 36.0169 27.9887 36.0169C28.8904 36.0169 29.6222 35.2874 29.6222 34.3857C29.6222 33.4863 28.8904 32.7545 27.9887 32.7545ZM37.5066 32.1786L39.8341 36.2104C39.9025 36.3285 39.9025 36.4748 39.8341 36.5928C39.7656 36.7109 39.6382 36.784 39.5012 36.784H34.8462C34.7093 36.784 34.5842 36.7109 34.5157 36.5928C34.4472 36.4748 34.4472 36.3285 34.5157 36.2104L36.8432 32.1786C36.9117 32.0605 37.0368 31.9874 37.1737 31.9874C37.3106 31.9874 37.4381 32.0605 37.5066 32.1786ZM37.1737 33.1393L35.5119 36.0169H38.8379L37.1737 33.1393Z",
    fill: "#06513D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13506_34426",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13506_34426"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13506_34426",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernancesSpeciallyAbled);
export default __webpack_public_path__ + "static/media/governances-specially-abled.8b151b252889a3783f6b9534123f70c0.svg";
export { ForwardRef as ReactComponent };